import styled, { withTheme, css } from 'styled-components'
import Konsys from 'modules/konsys-ui' // eslint-disable-line
import { theme } from '../../styles/_variables'

export const Icon = withTheme(Konsys.Icon)
export const Checkbox = withTheme(Konsys.Checkbox)
export const RadioGroup = withTheme(Konsys.RadioGroup)
export const TextLink = withTheme(Konsys.TextLink)
export const Loading = withTheme(Konsys.Loading)
export const Div = withTheme(Konsys.Div)
export const Select = withTheme(Konsys.Select)

export const InputWithLabel = withTheme(Konsys.InputWithLabel)
export const Input = withTheme(Konsys.Input)

export const H1 = withTheme(Konsys.H1)
export const H2 = withTheme(Konsys.H2)
export const H3 = withTheme(Konsys.H3)

const CustomH4 = styled(Konsys.H4)`
  font-family: ${props => (props.playfair ? 'PlayfairDisplay' : theme.fonts.family.normal)};
  font-weight: ${props => (props.playfair ? '700' : props.black ? theme.fonts.style.black : props.bold ? theme.fonts.style.bold : theme.fonts.style.regular)};
  ${props => props.letterSpacing && css`
    letter-spacing: ${props.letterSpacing};
  `}
`
export const H4 = withTheme(CustomH4)

const CustomP = styled(Konsys.P)`
  font-family: ${theme.fonts.family.normal};
  font-weight: ${props => (props.black ? theme.fonts.style.black : props.bold ? theme.fonts.style.bold : props.light ? theme.fonts.style.light : theme.fonts.style.regular)};
  ${props => props.letterSpacing && css`
    letter-spacing: ${props.letterSpacing};
  `}
`
export const P = withTheme(CustomP)

const CustomLabel = styled(Konsys.Label)`
  font-family: ${props => (props.font ? props.font : theme.fonts.family.normal)};
  font-weight:  ${props => (props.regular ? theme.fonts.style.regular : theme.fonts.style.light)};
`
export const Label = withTheme(CustomLabel)

const CustomSmallText = styled(Konsys.SmallText)`
  font-family: ${props => (props.font ? props.font : theme.fonts.family.normal)};
  font-weight:  ${props => (props.regular ? theme.fonts.style.regular : theme.fonts.style.light)};
`
export const SmallText = withTheme(CustomSmallText)


const CustomButton = styled(Konsys.Button)`
  > p {
    font-family: ${theme.fonts.family.normal};
    font-weight: ${theme.fonts.style.regular};
  }
`

export const Button = styled(withTheme(CustomButton))`
  &:disabled {
    cursor: not-allowed;
    background-color: #F6F3EF !important;
    border: 1px solid #EEE8E1 !important;
  }
`

export default Button



// WEBPACK FOOTER //
// ./src/components/common/konsys-ui.jsx